import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tabulation } from "@/mixins/index";
import { getAll, getsearch, delConsume } from "@/api/financial/consumptionDetails";
import addConsumption from "./components/addConsumption";
import uploadConsumptionCsv from "./components/uploadConsumptionCsv";
export default {
  name: "consumptionDetails",
  components: {
    addConsumption: addConsumption,
    uploadConsumptionCsv: uploadConsumptionCsv
  },
  mixins: [tabulation],
  data: function data() {
    return {
      searchData: {
        page: 1,
        page_size: 10,
        starttime: "",
        endtime: ""
      },
      tableData: [],
      addConsumption: false,
      total: 0,
      page: 1,
      adPlacementSingleChoice: true,
      issubstitution: false
    };
  },
  created: function created() {},
  methods: {
    searchClick: function searchClick(e) {
      var _this = this;

      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      // if (!this.searchData.special_product_id.toString() && type) {
      //   this.$message.error('请选择产品')
      //   return
      // }else if(!this.searchData.special_product_id.toString() && !type){
      //   return
      // }
      if (this.value2.length > 0) {
        this.searchData.starttime = this.value2[0];
        this.searchData.endtime = this.value2[1];
      }

      this.searchData.page = e;
      this.reqLoading = true;
      var searchData = JSON.parse(JSON.stringify(this.searchData));
      searchData.ad_placement = searchData.ad_placement == 'valuets' ? [''] : searchData.ad_placement; // searchData.game_id = ''

      getAll(searchData).then(function (res) {
        if (res.status == 200) {
          var list = ['game', 'platform', 'channel', 'pkg', 'ad_channel', 'ad_placement'];
          _this.tableData = res.data.data.length ? _this.$utils.dataConversion(res.data.data, list) : [];
          _this.total = res.data.total || 0;
        }
      }).finally(function () {
        _this.reqLoading = false;
      });
    },
    handleSource: function handleSource(row) {
      this.$refs.addConsumption.init(row);
    },
    handleDelete: function handleDelete(id) {
      var _this2 = this;

      this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                delConsume({
                  id: id
                }).then(function (res) {
                  _this2.searchClick(_this2.searchData.page);
                });

                _this2.$message({
                  type: "success",
                  message: "删除成功!"
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    }
  }
};